export default __webpack_public_path__ + "static/illustration-maximize-a11c5f512e18e640dae3ce9e4c0ea394.png";